'use strict';

import SignIn from './components/SignIn/SignIn';
import OTP from './components/Otp/Otp';
import HTTPError from './components/http_error';
import React from 'react';

class Router extends React.Component {

  state = apiAdapter.sendSerializer({
    component: {},
    params: {},
    ...this.props
  });

  render() {
    if (this.state.component === 'otp') return <OTP context={this.state.context} params={this.state.params} route={(a, b) => this.setState({ component: a, params: b })} />;
    if (this.state.component === 'http_error') return <HTTPError context={this.state.context} params={this.state.params} route={(a, b) => this.setState({ component: a, params: b })} />;
    return <SignIn context={this.state.context} params={this.state.params} route={(a, b) => this.setState({ component: a, params: b })} />;
  }
}

export default Router;
